import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { PageLayout } from '../components/PageLayout';
import img1 from '../images/aboutusimg/1.JPG';
import img2 from '../images/aboutusimg/2.JPG';
import img3 from '../images/aboutusimg/3.JPG';
import img4 from '../images/aboutusimg/4.JPG';
import img5 from '../images/aboutusimg/5.JPG';
import img6 from '../images/aboutusimg/6.JPG';
import img7 from '../images/aboutusimg/7.JPG';
import img8 from '../images/aboutusimg/8.JPG';
import img9 from '../images/aboutusimg/9.JPG';

import ContactCTA from '../components/ContactCTA';

const CharterTeam = () => {
  document.title = "About Us - Hampton Jitney Charters";
  return (
    <PageLayout>
      <div className="flex-grow overflow-y-scroll">
        <div className="border border-black rounded-lg p-4 mt-4 bg-white bg-opacity-75 mx-4">
          <h1 className="text-4xl font-bold mb-4 text-center">About Our Team</h1>
          <div className="w-full lg:w-1/2">
            <p class="text-2xl text-gray-800 mb-8">
              You plan, or we plan for you.
            </p>
            <p class="text-lg font-semibold text-gray-800 mb-8">
              Our talented Charter team can make all the arrangements to take your group anywhere
              you've planned, whether it be a day trip or a weekend excursion. We can order tickets,
              reserve rooms and arrange your meals - at group excursion rates. And if you want to do
              something but don't know what, ask us to plan for you.
            </p>
            <ContactCTA
              heroImg={img1}
              ctaText={"Contact a member of our Charter Team today"}
              bodyText={"Contact us at 631-287-4000, or <a href='mailto:charter@hamptonjitney.com'>charter@hamptonjitney.com</a>."}
            />
          </div>

          <Carousel
            className="flex justify-between w-[50%] mt-4 mx-auto mt-24"
            showArrows={true}
            infiniteLoop={true}
            showThumbs={false}
            showStatus={false}

          >
            <div>
              <img className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" src={img2} alt="img10" />
              <p className="mt-4 text-center text-gray-700"></p>
            </div>

            <div>
              <img className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" src={img3} alt="img10" />
              <p className="mt-4 text-center text-gray-700"></p>
            </div>

            <div>
              <img className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" src={img4} alt="img10" />
              <p className="mt-4 text-center text-gray-700"></p>
            </div>

            <div>
              <img className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" src={img5} alt="img10" />
              <p className="mt-4 text-center text-gray-700"></p>
            </div>

            <div>
              <img className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" src={img6} alt="img10" />
              <p className="mt-4 text-center text-gray-700"></p>
            </div>

            <div>
              <img className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" src={img7} alt="img10" />
              <p className="mt-4 text-center text-gray-700"></p>
            </div>

            <div>
              <img className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" src={img8} alt="img10" />
              <p className="mt-4 text-center text-gray-700"></p>
            </div>

            <div>
              <img className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" src={img9} alt="img10" />
              <p className="mt-4 text-center text-gray-700"></p>
            </div>

          </Carousel>

        </div>
      </div>
    </PageLayout>
  );
};

export default CharterTeam;
